/**
 * Module contract — what differs between the standards sets the grid can draw.
 *
 * Owns: per framework, the column tree, the domain order and the words the
 *       headers and tooltips use for each of the three levels.
 * Does not own: which framework a session gets — demoStandardsFramework in
 *       service/demoAnalytics decides that.
 */

import type { DomainNode } from "../types/standards";
import type { DemoStandardsFramework } from "../service/demoAnalytics";
import { STANDARDS_MAP } from "./standardsMap";
import { NEBRASKA_STANDARDS_MAP } from "./nebraskaStandardsMap";

export type StandardsFrameworkConfig = {
  /** Shown after "Standard Mastery :". */
  label: string;
  map: DomainNode[];
  /** Domain codes in display order; absent means alphabetical by name. */
  domainOrder?: string[];
  /** Singular nouns for the domain, cluster and standard levels. */
  terms: { domain: string; cluster: string; standard: string };
  /** A cluster's letter already names its domain ("3.G.2", not "3A"). */
  isClusterLetterFullCode: boolean;
};

export const STANDARDS_FRAMEWORKS: Record<
  DemoStandardsFramework,
  StandardsFrameworkConfig
> = {
  common_core: {
    label: "Common Core",
    map: STANDARDS_MAP,
    terms: { domain: "domain", cluster: "cluster", standard: "standard" },
    isClusterLetterFullCode: false,
  },
  nebraska: {
    label: "Nebraska",
    map: NEBRASKA_STANDARDS_MAP,
    domainOrder: ["N", "R", "A", "G", "D"],
    terms: { domain: "strand", cluster: "standard", standard: "indicator" },
    isClusterLetterFullCode: true,
  },
};
